import React from "react"
import LocalEventForm from './LocalEventForm'

export default class LocalEventCard extends React.Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col">
            <ul className="list-group collapsible col-12 pr-0 mb-3 local-events-list" data-collapsible="expandable">
              <li className={"list-group-item p-0 " + (this.props.local_event.id ? "" : "active")}>
                <div className={"collapsible-header py-3 d-flex w-100 align-items-center cursor-pointer " + (this.props.local_event.id ? "" : "active")}>
                  <div className="d-flex flex-column pl-3">
                    <h3 className="m-0">{this.props.local_event.title}</h3>
                  </div>
                  <div className="col"></div>
                  <div className="d-flex flex-column grey-text text-darken-2 align-items-end pr-3">
                    <i className="material-icons rotate-icon">keyboard_arrow_down</i>
                  </div>
                </div>
                <div className="collapsible-body pt-2 w-100">
                  <LocalEventForm local_event={this.props.local_event} eventErrors={this.props.eventErrors} onDelete={this.props.onDelete}
                    onSave={this.props.onSave} onEventUpdate={this.props.onEventUpdate} />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
